export { default } from '../../../src/features/setup/screens/CreateUserScreen'
